import { render, staticRenderFns } from "./PriceProposal.vue?vue&type=template&id=afffdc5a"
import script from "./PriceProposal.vue?vue&type=script&lang=js"
export * from "./PriceProposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports